import { find } from "lodash";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Tag } from "../../App/components/atoms";
import { AdminPage } from "../../App/layout/AdminPage/AdminPage";

const currentMenu = [
  // appendRouteHere

  {
    key: "vendors",
    label: "Vendors",
    link: "/inventory/vendors",
  },
  {
    key: "categories",
    label: "Categories",
    link: "/inventory/categories",
  },
  {
    key: "units",
    label: "Units",
    link: "/inventory/units",
  },
  {
    key: "products",
    label: "Products",
    link: "/inventory/products",
  },
  {
    key: "ingredients",
    label: "Ingredients",
    link: "/inventory/ingredients",
  },
];
const currentBreadcrumb = (name: string) => [
  {
    key: "page",
    label: name,
    link: "#",
  },
];

const InventoryPage: React.FC = () => {
  const location = useLocation();
  const [pageName, setPageName] = React.useState<string>("");
  const [breadcrumb, setBreadcrumb] = React.useState<any[]>([]);
  React.useEffect(() => {
    const name = find(currentMenu, ["link", location.pathname]);
    setBreadcrumb(currentBreadcrumb(name?.label || "") || []);
    setPageName(name?.label || "");
  }, [location.pathname]);

  return (
    <AdminPage
      title={
        <div className="admin-page-title">
          Inventory <Tag>{pageName}</Tag>
        </div>
      }
      headerMenu={currentMenu}
      breadcrumb={breadcrumb}
    >
      <Outlet />
    </AdminPage>
  );
};

export default InventoryPage;
